import React, { Component } from "react";
import { Text } from "react-internationalization";
import history from "../../Utils/History";
import SignaturePad from "react-signature-canvas";
import SoaDocument1 from "../soapdf/SoaDocument1";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { connect } from "react-redux";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import {
  deleteFile,
  getsepReasons,
  setStateParams,
} from "../../Redux/Actions/webAppActions";
import { INITIAL_STATE } from "../initialState";
import AutoComplete1 from "../../Utils/GenericUI/Select";
import AutoComplete from "../../Utils/Select";
import { VerdaTermsAndCondition } from "../TermsAndConditions/DefaultTermNdCondition";
import {
  DataValidation,
  NEBRASKA_CONSTS,
  VERDA_CONSTS,
  ILS_CONSTS
} from "../../Utils/StaticData/Constant";
import { FieldLabel } from "../translations/dynamic";
const categoryOptions = [
  { label: "Select", value: "" },
  { label: "E-ENROLLMENT AGENT", value: "E-ENROLL AGENT" },
  { label: "E-ENROLLMENT TELEPHONE", value: "E-ENROLL TELEPHONE" },
  { label: "E-ENROLLMENT PAPER", value: "E-ENROLL PAPER" },
];
const NeBraska_Agent_fields = [
  // {
  //   type:"text",
  //   name:"agentNumber",
  //   label:"Agent Number:",
  //   len:10,
  //   disable:true
  // },
  {
    type: "text",
    name: "agentTaxId",
    label: "Agent Tax Id:",
    len: 10,
     disable: true,
  },
  {
    type: "text",
    name: "agentEmail",
    label: "Email of Producing Agent(Optional):",
    len: 30,

    disable: true,
   
  },
  {
    type: "text",
    name: "enrlDate",
    label: "Date producing agent accepted paper enrollment(Optional):",
    len: 10,
    placeholder: "MM/DD/YYYY",
    disable: false,
  },
];
const Ils_Agent_fields = [
  {
    type: "text",
    name: "agentTaxId",
    label: <Text id="step5Agent.watin"/>,
    len: 10,
    disable: true,
  },
  {
    type: "text",
    name: "agentTaxId",
    label: <Text id="step5Agent.atin"/>,
    len: 10,
    disable: true,
  },
];
class Step5Agent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ready: false,
      selectedQnId: this?.props?.selectedQnId,
    };
    this.validator = new SimpleReactValidator();
    this.sigPad = {};
  }
  handleChangeDropDown = (name) => (event) => {
    let value = "";
    value = event.target ? event.target.value : event.value;
    this.setState((prevState) => ({
      ...prevState,
      data: { ...prevState.data, [name]: value },
    }));
  };
  async componentDidMount() {
    const { pendingApplFlag, planCardData, productId } = this.props;
    if (!pendingApplFlag) {
      const filteredCardInfo = planCardData.filter(
        (card) => card.productId === productId
      )[0];

      this.props.setStateParams("planSelected", { planId:filteredCardInfo?.planId??"", pbpId:filteredCardInfo?.pbpId??"" });
    }
    if (
      this.props.data.agentSign !== "" &&
      this.props.pendingApplFlag === false
    ) {
      var canvas = document.getElementById("sigCanvas");
      var context = canvas?.getContext("2d");
      var img = new Image();
      img.src = this.props.data.agentSign;
      img.onload = function () {
        let newWidth =
          img.width > canvas.width ? canvas.width / 1.5 : img.width / 1.5;
        let newHeight =
          img.height > canvas.height ? canvas.height / 1.5 : img.height / 1.5;
        context.drawImage(img, 0, 0, newWidth, newHeight);
      };
      let image = new Image();
      image.src = this.props.data.agentSign;
      document.getElementById("sigImg").replaceChildren();
      document.getElementById("sigImg").appendChild(image);
      return;
    }

    for (let i = 0; i < this.props.data?.attachmentList?.length; i++) {
      if (this.props.data?.attachmentList[i]?.attachmentType === "SIGNATURE") {
        // await this.props.saveSign(this.sigPad.fromDataURL(this.props.data?.attachmentList[i]?.sign),false);
        var canvas1 = document.getElementById("sigCanvas");
        var context1 = canvas1.getContext("2d");
        var img1 = new Image();
        img1.src = this.props.data?.attachmentList[i]?.sign;
        // img1.width="50%"
        // img1.height="50%"

        img1.onload = function () {
          // console.log("hh-",canvas1.width,canvas1.height,img1.width,img1.height)
          // let loadedImageWidth = img1.width;
          // let loadedImageHeight = img1.height;
          let newWidth =
            img1.width > canvas1.width ? canvas1.width / 1.5 : img1.width / 1.5;
          let newHeight =
            img1.height > canvas1.height
              ? canvas1.height / 1.5
              : img1.height / 1.5;
          // let x = (canvas1.width / 2) - (newWidth / 2);
          // let y = (canvas1.height / 2) - (newHeight / 2);
          context1.drawImage(img1, 0, 0, newWidth, newHeight);
        };
        let image1 = new Image();
        image1.src = this.props.data?.attachmentList[i]?.sign;
        document.getElementById("sigImg").replaceChildren();
        document.getElementById("sigImg").appendChild(image1);
        return;
      }
    }
    if (this.props.data.agentSign) {
      var canvas2 = document.getElementById("sigCanvas");
      var context2 = canvas2?.getContext("2d");
      let img2 = new Image();
      img2.src = this.props.data.agentSign;
      img2.onload = function () {
        let newWidth =
          img2.width > canvas2.width ? canvas2.width / 1.5 : img2.width / 1.5;
        let newHeight =
          img2.height > canvas2.height
            ? canvas2.height / 1.5
            : img2.height / 1.5;
        context2.drawImage(img2, 0, 0, newWidth, newHeight);
      };
      let image2 = new Image();
      image2.src = this.props.data.agentSign;
      document.getElementById("sigImg").replaceChildren();
      document.getElementById("sigImg").appendChild(image2);
    }
    
  }
  toggle = () => {
    this.setState(
      (prevState) => ({
        ready: false,
      }),
      () => {
        setTimeout(() => {
          this.setState({ ready: true });
        }, 1);
      }
    );
  };
  clear = async () => {
    for (let i = 0; i < this.props?.data?.attachmentList?.length; i++) {
      if (this.props.data?.attachmentList[i]?.attachmentType === "SIGNATURE") {
        let appNum = this.props.getData();
        await this.props.deleteFile({
          appNumber: appNum.appNumber,
          attachmentId: this.props.data?.attachmentList[i]?.attachmentId,
          attachmentName: this.props.data?.attachmentList[i]?.attachmentName,
          customerId: this.props?.customerId,
        });
      }
    }
    this.props.filterDeletedSignature();
    this.sigPad.clear();
    this.props.clear();
    document.getElementById("sigImg").replaceChildren();
  };
  save = () => {
    this.props.saveSign(
      this.sigPad.getTrimmedCanvas().toDataURL("image/png"),
      true
    );
    let bse65Img = this.sigPad.getTrimmedCanvas().toDataURL("image/png");
    document.getElementById("sigImg").replaceChildren();
    if (
      bse65Img !==
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAAtJREFUGFdjYAACAAAFAAGq1chRAAAAAElFTkSuQmCC"
    ) {
      let canvasEle = this.sigPad.getTrimmedCanvas();
      let image = new Image();
      image.src = canvasEle.toDataURL();
      document.getElementById("sigImg").replaceChildren();
      document.getElementById("sigImg").appendChild(image);
    }
  };
  render() {
    // console.log("selected--",this?.state?.selectedQnId,this.props.data)
    const type =
      (this.props?.electionList??[]).filter(
        (items) => items?.value === this.props?.electionType
      )?.length > 0
        ? this.props?.electionList.filter(
            (items1) => items1?.value === this.props?.electionType
          )[0].value
        : "";
    const { data } = this.props;

    return (
      <React.Fragment>
        <div
          class={
            data.appStatus === "READY" || data.appStatus === "SUBMITTED"
              ? "tab-content tab-contentSharp disable-form"
              : "tab-content tab-contentSharp"
          }
        >
          <div id="step4" class="container-Cambia tab-pane active">
            <h3 class="tab-heading mb-3">
              <Text id="step5Agent.step5" /> – <Text id="step5Agent.heading" />
            </h3>
            {this.props.customerId===ILS_CONSTS.ID && this.props.year!=="2025" &&
            <div class="card mt-3">
            <h3 class="card-header block-heading">
              <Text id="ils.step5.privacyHeader" />
            </h3>
            <div class="panel">
              <div class="card-body">
                <p><Text id="ils.step5.privacyContent1"/></p>
                <p className="mt-3"><strong><Text id="ils.step5.privacyContent2"/></strong></p>
              </div>
            </div>
          </div>
            }
            {this.props.customerId===ILS_CONSTS.ID && this.props.year==="2025" &&
                <p className="mt-1"><strong><Text id="ils.step5.privacyContent2"/></strong></p>
            }
            {/* new */}
            <label class="control-label mt-3 fontSize19px fontwght500">
              <strong>
                <Text id="app.officeUse" />
              </strong>
            </label>
            <div class="row">
              <div class="col">
                <p>
                  <Text id="app.agentbroker" />
                  :&nbsp;
                  <strong>{this.props?.agentfullname}</strong>
                </p>
                <br />
                <p>
                  <Text id="app.effdofcov" />
                  :&nbsp;
                  <strong>{data?.proposedEffDate}</strong>
                </p>
                <br />
                <p>
                  <Text id="app.SEPRsn" />
                  :&nbsp;
                  <div class="display-inline-block">
                    {
                      //this?.props?.electionType !="S"
                      this?.state?.selectedQnId?.length > 0 ? (
                        <AutoComplete1
                          handleChange={this.props.handleChangeCategory(
                            "sepReasonCd"
                          )}
                          options={
                            type === "S"
                              ? this.props?.sepReasonforS
                              : this.props?.sepList
                          }
                          disabled={
                            type === "S"
                              ? this.props.qsns
                                  .filter(
                                    (qs) =>
                                      qs.questionId ==
                                      this?.state?.selectedQnId[0]
                                  )[0]
                                  ?.sepReasonCd?.trim() === ""
                                ? false
                                : "true"
                              : "true"
                          }
                          //defaultValue={this.props?.sepList.filter((el)=>this?.state?.selectedQnId.includes(el.questionId))[0]}
                          value={
                            type === "S"
                              ? this.props?.sepReasonforS.filter(
                                  (el) =>
                                    el.value.includes(data?.sepReasonCd) ||
                                    el.label.includes(
                                      this.props.data?.sepReasonCd.trim()
                                    )
                                )?.length > 0 && data?.sepReasonCd?.trim()
                                ? this.props?.sepReasonforS.filter(
                                    (el) =>
                                      el.value.includes(data?.sepReasonCd) ||
                                      el.label.includes(
                                        this.props.data?.sepReasonCd.trim()
                                      )
                                  )[0]
                                : { label: "---Select---", value: "" }
                              : this.props?.sepList.filter((el) =>
                                  this?.state?.selectedQnId.includes(
                                    el.questionId
                                  )
                                )?.length > 0
                              ? this.props?.sepList.filter((el) =>
                                  this?.state?.selectedQnId.includes(
                                    el.questionId
                                  )
                                )[0]
                              : { label: "---Select---", value: "" }
                          }
                          margin="20px auto"
                          width={"236px"}
                          show={true}
                          error={this.props.data?.sepReasonCd.trim() === ""}
                        />
                      ) : (
                        <AutoComplete1
                          handleChange={this.props.handleChangeCategory(
                            "sepReasonCd"
                          )}
                          options={this.props?.sepReasonforS}
                          //defaultValue={this.props?.sepList.filter((el)=>this?.state?.selectedQnId.includes(el.questionId))[0]}

                          value={
                            this.props?.sepReasonforS?.length > 0 &&
                            this.props?.sepReasonforS?.filter(
                              (obj) => obj.value === data?.sepReasonCd
                            )?.length > 0
                              ? this.props?.sepReasonforS?.filter(
                                  (obj) => obj.value === data?.sepReasonCd
                                )[0]
                              : { label: "---Select---", value: "" }
                          }
                          error={
                            this.props?.sepReasonforS?.length === 0 ||
                            (this.props?.sepReasonforS?.length > 0 &&
                              this.props?.sepReasonforS?.filter(
                                (obj) => obj.value === data?.sepReasonCd
                              )?.length === 0)
                          }
                          // error={this.props?.sepReasonforS?.length === 0 ? true : false}
                          margin="20px auto"
                          width={"236px"}
                          show={true}
                        />
                      )
                    }
                  </div>
                  {/* <strong>{data?.prefix}</strong> */}
                </p>
              </div>
              <div class="col">
                <p>
                  <Text id="app.planid" />
                  :&nbsp;
                  <strong>
                    {this.props?.planSelecteddetails?.planId +
                      "/" +
                      this.props?.planSelecteddetails?.pbpId}
                  </strong>
                </p>
                <p>
                  <Text id="app.electntype" />
                  :&nbsp;
                  <div class="display-inline-block">
                    <AutoComplete1
                      width={"236px"}
                      handleChange={this.props.handleChangeCategory(
                        "electiontype"
                      )}
                      //label="Application Category*"
                      options={this.props?.electionList??[]}
                      disabled="true"
                      value={
                        (this.props?.electionList??[]).filter(
                          (item) => item?.value === this.props?.electionType
                        )?.length > 0
                          ? this.props?.electionList.filter(
                              (item) => item?.value === this.props?.electionType
                            )[0]
                          : { label: "---Select---", value: "" }
                      }
                      margin="20px auto"
                      show={true}
                    />
                  </div>
                </p>
                {this.props.customerId===ILS_CONSTS.ID && <>
                <p>
                  <Text id="app.FirstName" />
                  :&nbsp;
                  <strong>{this.props.firstName}</strong>
                </p>
                <p>
                  <Text id="app.LastName" />
                  :&nbsp;
                  <strong>{this.props.lastName}</strong>
                </p>
                </>}
              </div>
            </div>
            {this.props.customerId === NEBRASKA_CONSTS.ID && (
              <div class="form-group row">
                <div class="col-md-4">
                  <label for="name" class="control-label">
                    Agent Number:
                  </label>
                  <input
                    type="text"
                    id="agentNumber"
                    name="agentNumber"
                    value={this.props.agentId}
                    class={this.props.agentId ? "form-control" : "error-input"}
                    disabled={true}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                {NeBraska_Agent_fields.map((e) => (
                  <div class="col-md-4">
                    <label for="name" class="control-label">
                      {e?.label}
                    </label>
                    <input
                      type={e?.type}
                      id={e?.name}
                      name={e?.name}
                      value={data[e?.name]}
                      maxLength={e?.len}
                      onChange={
                        e?.name == "enrlDate"
                          ? (event) => this.props.handleDate(event)
                          : (event) => this.props.handleChange(event)
                      }
                      onClick={
                        e?.name == "enrlDate"
                          ? (event) => {
                              this.props.handleDates("enrlDate");
                            }
                          : () => {}
                      }
                      class={
                        e?.name == "enrlDate"
                          ? data[e?.name] &&
                            !moment(data[e?.name], "MM/DD/YYYY", true).isValid()
                            ? "error-input scrollfix"
                            : "form-control  scrollfix"
                          : e?.name === "agentEmail"
                          ? // !data["agentEmail"] ||
                            !this.validator.check(data["agentEmail"], "email")
                            ? "error-input"
                            : "form-control"
                          : (
                              e?.name === "agentTaxId"
                                ? this.props.agentTaxId
                                : data[e?.name]
                            )
                          ? "form-control"
                          : "error-input"
                      }
                      disabled={e?.disable}
                      placeholder={e?.placeholder}
                      autoComplete="off"
                      spellcheck="false"
                      aria-autocomplete="both"
                      aria-haspopup="false"
                    />
                  </div>
                ))}
              </div>
            )}
            {this.props.customerId===ILS_CONSTS.ID && <div className="row">{Ils_Agent_fields.map((e) => (
                  <div class="col-md-4">
                    <label for="name" class="control-label">
                      {e?.label}
                    </label>
                    <input
                      type={e?.type}
                      id={e?.name}
                      name={e?.name}
                      value={this.props.agentTaxId}
                      maxLength={e?.len}
                      class={"form-control"}
                      disabled={e?.disable}
                      placeholder={e?.placeholder}
                      autoComplete="off"
                    />
                  </div>
                ))}
                </div>}
            {this.props.customerId === VERDA_CONSTS.ID ? (
              <VerdaTermsAndCondition />
            ) : (
              <div class="card mt-3">
                <h3 class="card-header block-heading">
                  <Text id="app.imp" /> : <Text id="app.impsub" />
                </h3>
                <div class="panel">
                  <div class="card-body">
                    {FieldLabel("readAndSign", this.props.customerId)}
                  </div>
                </div>
              </div>
            )}
            <div>
              <div class="checkbox checkbox-tab mt-1">
                <div>
                  <label for="agreement">
                    <input
                      type="checkbox"
                      checked={data.termsAndConditions === "Y" ? true : false}
                      id="agreement"
                      name="termsAndConditions"
                      class={
                        data.termsAndConditions != "Y"
                          ? "checkbox-input-error"
                          : "checkbox-input"
                      }
                      onChange={this.props.handleChange}
                    />
                    &nbsp;
                    <strong>
                      <Text id="app.terms" />
                    </strong>
                  </label>
                </div>
              </div>
              <br />

              <div class="form-group row">
                <div class="col-md-4">
                  <AutoComplete1
                    handleChange={this.props.handleChangeCategory("applcat")}
                    label={<Text id="step5Agent.appcat"/>}
                    options={
                      this.props.customerId === VERDA_CONSTS.ID ||
                      this.props.customerId === NEBRASKA_CONSTS.ID
                        ? categoryOptions
                        : categoryOptions.slice(0, 3)
                    }
                    // disabled = "true"
                    defaultValue={categoryOptions?.find(
                      (data1) => data1?.value === ""
                    )}
                    value={categoryOptions?.find(
                      (data2) => data2?.value === this.props.data.applcat
                    )}
                    // name="Agent List"
                    margin="20px auto"
                    width="100%"
                    show={true}
                    error={this.props.data.applcat === "" ? true : false}
                  />
                </div>
              </div>
              {/* <div class="form-group row"> */}
              {this.props.customerId === VERDA_CONSTS.ID &&
                (this.props.data?.applcat === "E-ENROLL TELEPHONE" ||
                  this.props.data?.applcat === "E-ENROLL PAPER") && (
                  <div class="checkbox checkbox-tab mt-1">
                    <div>
                      <label for="verbiage">
                        <input
                          type="checkbox"
                          checked={data.verbiage === "Y" ? true : false}
                          id="verbiage"
                          name="verbiage"
                          class={
                            // data.verbiage != "Y"
                            // ? "checkbox-input-error"
                            "checkbox-input"
                          }
                          onChange={this.props.handleChange}
                        />
                        &nbsp;
                        <strong>
                          <Text id="verda.verbiage" />
                          <strong className="mandatory-field-bold">*</strong>
                        </strong>
                      </label>
                    </div>
                  </div>
                )}
              {/* </div> */}
              <div class="form-group row">
                <div class="col-md-4">
                  <label for="name" class="control-label">
                    <Text id="app.Name" />
                    {this.props.data?.applcat === "E-ENROLL TELEPHONE" ||
                    this.props.data?.applcat === "E-ENROLL PAPER"
                      ? "*"
                      : ""}
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={data.name}
                    maxLength="50"
                    onChange={(event) => {
                      if (
                        event.target.value !== "" &&
                        !DataValidation.test(event.target.value)
                      ) {
                        return;
                      }
                      this.props.handleChange(event);
                    }}
                    class={
                      this.props.data.name === "" &&
                      (this.props.data?.applcat === "E-ENROLL TELEPHONE" ||
                        this.props.data?.applcat === "E-ENROLL PAPER")
                        ? "error-input"
                        : "form-control"
                    }
                    disabled={
                      this.props.customerId === VERDA_CONSTS.ID
                        ? this.props.data?.applcat === "" ||
                          ((this.props.data?.applcat === "E-ENROLL TELEPHONE" ||
                            this.props.data?.applcat === "E-ENROLL PAPER") &&
                            data.verbiage !== "Y")
                        : false
                    }
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="col-md-4">
                  <label for="name" class="control-label">
                    <Text id="app.DigitalSignature" />
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    maxLength="50"
                    disabled="true"
                    style={{ cursor: "not-allowed" }}
                    value={data.name}
                    onChange={this.props.handleChange}
                    class={"form-control"}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="col-md-4">
                  <label for="todaysDate" class="control-label">
                    <Text id="app.TodayDate" />
                  </label>
                  <input
                    type="text"
                    style={{ cursor: "not-allowed" }}
                    id="todaysDate"
                    name="todaysDate"
                    disabled="true"
                    value={
                      new Date()
                        .toLocaleString("en-US", {
                          timeZone:
                            Intl.DateTimeFormat().resolvedOptions().timeZone,
                        })
                        .split(",")[0]
                    }
                    //onChange={this.props.handleChange}
                    class={"form-control"}
                    autoComplete="off"
                    spellcheck="false"
                    aria-autocomplete="both"
                    aria-haspopup="false"
                  />
                </div>
                <div class="mt-3 col-md-12">
                  <label class="control-label" for="fileUpload">
                    <Text id="step4Agent.sign" />
                    {this.props.data?.applcat === "E-ENROLL AGENT" ? "*" : ""}
                  </label>
                  <div class="card">
                    <div
                      className="card-header"
                      style={{ display: "inline-flex" }}
                    >
                      <div>
                        <button
                          className="btn btn-success mr-2 mb-1"
                          onClick={this.save}
                        >
                          <Text id="step5Agent.savesign"/>
                        </button>
                        <button
                          className="btn btn-danger mb-1"
                          onClick={this.clear}
                        >
                          <i className="fa fa-times" aria-hidden="true"></i>
                          &nbsp;
                          <Text id="step4Agent.clear" />
                        </button>
                      </div>
                    </div>
                    <div class="panel">
                      <div
                        class={
                          this.props.data?.applcat === "E-ENROLL AGENT"
                            ? this.props.data?.attachmentList?.some(
                                (x) => x?.attachmentType === "SIGNATURE"
                              )
                              ? "card-body card-body-padding "
                              : this.props.data?.agentSign === "" ||
                                this.props.data?.agentSign == undefined
                              ? "card-body card-body-padding sig-border "
                              : "card-body card-body-padding "
                            : "card-body card-body-padding "
                        }
                      >
                        <SignaturePad
                          clearOnResize={false}
                          ref={(ref) => {
                            this.sigPad = ref;
                          }}
                          canvasProps={{
                            // className: "sigCanvas",
                            height: 200,
                            width: 1025,
                            id: "sigCanvas",
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div id="sigImg" class="col-md-2 mt-3 digital-img"></div>
              </div>
              {this.props.preEnrollInfo?.appStatus != "READY" &&
                this.props.preEnrollInfo?.appStatus != "SUBMITTED" && (
                  <button
                    class="btn btn-saveNext"
                    id="next5"
                    onClick={this.props.redirect}
                    style={{ backgroundColor: "#603167" }}
                    disabled={
                      this.props?.Submitted ||
                      this.props.preEnrollInfo?.appStatus === "READY" ||
                      this.props.preEnrollInfo?.appStatus === "SUBMITTED"
                    }
                  >
                    <Text id="app.Save_Next" />
                  </button>
                )}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    electionType: state.webApp.electionType,
    firstName: state.login.firstName,
    lastName: state.login.lastName,
    agentId: state.login.agentId,
    physiciansData: state.webApp.physiciansData,
    preEnrollInfo: state.webApp.preEnrollInfo,
    Submitted: state.webApp.Submitted,
    customerId: state.login.customerId,
    sepList: state.webApp.sepList,
    electionList: state.webApp.electionList,
    agentfullname: state.login.agentFullName,
    planSelecteddetails: state.webApp.planSelected,
    sepReasonforS: state.login.sepReasonforS,
    pendingApplFlag: state.webApp.pendingApplFlag,
    qsns: state.webApp.qsns,
    planCardData: state.webApp.planCardData,
    productId: state.login.productId,
    agentTaxId: state.login.agentTaxId,
    agentEmailId: state.login.agentEmailId,
     year: state.webApp.year?.planYear
      ? state.webApp.year.planYear
      : state.webApp.year,
  };
};

const mapDispatchToProps = {
  deleteFile,
  getsepReasons,
  setStateParams,
};
export default connect(mapStateToProps, mapDispatchToProps)(Step5Agent);
